import { useEffect } from 'react';

import {
  useExportMeta,
  useExportPreview,
  useExportRequest,
  useExportSettings
} from '@/features/DataHub/modules/Export/context/exportContexts';
import type { ExportOption, PreviewConfig } from '@/features/DataHub/modules/Export/types';

import useActivePreview from './useActivePreview';
import { DEFAULT_API_KEY_PLACEHOLDER } from './useExportApiKey';

const usePreviewData = (exportOption: ExportOption, previewConfig: PreviewConfig | undefined) => {
  const { exportSettings } = useExportSettings();
  const { exportApiRequestString } = useExportMeta();
  const { setPreviewLoading } = useExportPreview();
  const { capturePosthogEvent } = useExportRequest();

  const { loading, error, fileContent, displayContent, downloadFile } = useActivePreview({
    exportOption,
    previewConfig,
    capturePosthogEvent,
    exportApiRequestString,
    exportSettings,
    displayApiKey: DEFAULT_API_KEY_PLACEHOLDER
  });

  useEffect(() => {
    setPreviewLoading(loading);
    return () => {
      setPreviewLoading(false);
    };
  }, [loading, setPreviewLoading]);

  return { loading, error, fileContent, downloadFile, content: displayContent };
};

export default usePreviewData;
